<template>
    <Breadcrumbs main="Gallery" title="Masonry Gallery With Description" />
    <div class="container-fluid">
        <div class="row">
            <masonryDesc />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const masonryDesc = defineAsyncComponent(() => import("@/components/theme/gallery/masonry/masonryDesc.vue"))
</script>